import { app } from '../../../bootstrap/core';
import {
  TicketTableDateFilter,
  TicketStatusClassName,
  TicketListBreadcrumbs,
} from './ticketOverview.constants';
import {
  transferringListState,
  receivingListState,
  transferringListStateName,
  receivingListStateName,
} from './ticketOverview.state';
import { ticketOverviewComponent } from './ticketOverview.component';
import { TicketFilterService } from './ticketFilter.service';
import '../../../common/ui/ticket/ticketTable/ticketTable';
import '../../../common/ui/ticket/ticketTableHeader/ticketTableHeader';

app
  .component(ticketOverviewComponent.name, ticketOverviewComponent)
  .config(receivingListState)
  .config(transferringListState)
  .constant('TicketStatusClassName', TicketStatusClassName)
  .constant('TicketTableDateFilter', TicketTableDateFilter)
  .constant('TicketListBreadcrumbs', TicketListBreadcrumbs)
  .constant('transferringListStateName', transferringListStateName)
  .constant('receivingListStateName', receivingListStateName)
  .service('TicketFilterService', TicketFilterService);
